import React from 'react'
import Confirm from 'views/confirm/confirm'

import { localize } from 'helpers/translator'

const QuizInitializeErrorConfirm = () => (
	<Confirm
		btOne={localize('global_cancel')}
		btTwo={localize('global_retry')}
		alertMessage={localize('global_generic_error')}
		actionButtonType={0}
		actionOne={() => {
			window.history.back()
		}}
		actionTwo={() => {
			location.reload()
		}}
		closeAction={() => {}}
		closeButton={false}
	/>
)

export default QuizInitializeErrorConfirm
